import "@babel/polyfill";
import { login, logout } from "./login";
import { updateSettings } from "./updateSettings";
import { buildPallet, deletePallet } from "./buildPallet";
import { createItem, editItem, deleteItem } from "./itemDel";
import { getQueuedProduct } from "./productDel";
import { sendCarrier } from "./sendCarrier";
import { prepPallet } from "./prepPallet";
import {
  listProduct,
  saveProduct,
  unlistProduct,
  uploadProductImage,
  deleteProductImage,
  markAsSold,
} from "./listProduct";
import { showAlert } from "./alert";

// DOM ELEMENTS
const loginForm = document.querySelector(".form--login");
const logOutBtn = document.querySelector(".nav__el--logout");
const userDataForm = document.querySelector(".form-user-data");
const csvDataForm = document.querySelector(".calc-form");
const userPasswordForm = document.querySelector(".form-user-password");
const deletePalletBtn = document.querySelector(".pallet-dlt");
const sellPalletBtn = document.querySelector(".palletDet-sell-btn");
const addItemForm = document.querySelector(".form-add-item");
const editItemForms = [...document.querySelectorAll(".edit-item-form")];
const contactForm = document.querySelector(".contact-form");
const navLiBack = [...document.querySelectorAll(".nav-back-li")];
const listThisForm = document.querySelector(".ltd-product-form");
const addFeatureBtn = document.querySelector(".add-feature-btn");
const removeFeatureBtn = [
  ...document.querySelectorAll(".existing-feature-remove"),
];
const unlistBtn = [...document.querySelectorAll(".my-product-unlist")];
const soldBtn = [...document.querySelectorAll(".my-product-sold")];
const imgDrop = document.getElementById("list-drop-area");
const imgFileDrop = document.getElementById("list-img-file");
const imgViewDrop = document.getElementById("list-img-view");
const addImgBtn = document.querySelector(".lt-image-confirm-upload");
const carouselBtns = document.querySelectorAll("[data-carousel-btn]");
const paginator = document.querySelector(".paginator");
const pagNext = document.querySelector(".pag-pg-nxt");
const pagBack = document.querySelector(".pag-back");
const filterApplyBtn = document.querySelector(".filter-options-apply");
const allFilterCheckBoxes = document.querySelectorAll(".filter-item-checkbox");
const filterInputOthers = document.querySelectorAll(".filter-item-others");
const productImageDeleteBtn = document.querySelectorAll(".lt-image-delete");

// Query String Deligation
if (paginator) {
  const newURL = new URL(window.location.href);
  const currPage = Number(newURL.searchParams.get("page")) || 1;
  // Event listener for "next"
  if (pagNext) {
    pagNext.addEventListener("click", (e) => {
      e.preventDefault();

      newURL.searchParams.set("page", currPage + 1);

      console.log("Current page number:", currPage);
      console.log("NEXT page number:", newURL);
      window.location.href = newURL;
    });
  }
  // Event listener for "back"
  if (pagBack) {
    pagBack.addEventListener("click", (e) => {
      e.preventDefault();

      newURL.searchParams.set("page", currPage - 1);

      console.log("Current page number:", currPage);
      console.log("NEXT page number:", newURL);
      window.location.href = newURL;
    });
  }
  // Event listener for number selector
  const pagNr = document.querySelectorAll(".pag-pg-nr");
  if (pagNr.length > 0) {
    pagNr.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const pageNumber = e.target.textContent.trim();
        newURL.searchParams.set("page", pageNumber);
        window.location.href = newURL.toString();
      });
    });
  }
}
// Query String filtering
if (filterInputOthers.length > 0) {
  filterInputOthers.forEach((input) => {
    input.addEventListener("change", (e) => {
      e.preventDefault();
      // Uncheck "All"
      document.querySelector(".filter-item-all").checked = false;
    });
  });
}
if (filterApplyBtn) {
  filterApplyBtn.addEventListener("click", (e) => {
    let newURL = new URL(window.location.href);

    if (document.querySelector(".filter-item-all").checked) {
      newURL.searchParams.delete("category");
    } else {
      const checkedTexts = Array.from(
        document.querySelectorAll(".filter-item-checkbox:checked + h3")
      ).map((h3) => h3.innerText);

      // Create query string
      const categoryParam = checkedTexts
        .map((item) => item.replace(/\s+/g, "+"))
        .join(",");

      // Build new URL from currURL
      newURL.searchParams.set("category", categoryParam);
    }

    // If no checkboxes are checked, default query string
    if (Array.from(allFilterCheckBoxes).every((cb) => !cb.checked)) {
      newURL.searchParams.delete("category");
      newURL.searchParams.delete("page");
    }
    window.location.href = newURL;
  });
}

// Image delegation
if (imgFileDrop) {
  const element = document.querySelector(".product-header");
  const productID = element?.className.split(" ").pop();

  function uploadImage() {
    let imgLink = URL.createObjectURL(imgFileDrop.files[0]);
    imgViewDrop.style.backgroundImage = `url(${imgLink})`;
    imgViewDrop.textContent = "";
    imgViewDrop.style.border = 0;
    // Showing button
    addImgBtn.style.display = "flex";

    // To back
    const formData = new FormData();
    formData.append("productImage", imgFileDrop.files[0]);
    formData.append("product", productID);
    console.log(formData);
    uploadProductImage(formData);
  }

  // For file upload
  imgFileDrop.addEventListener("change", uploadImage);

  // For drag & drop fucntionality
  imgDrop.addEventListener("dragover", (e) => {
    e.preventDefault();
  });
  imgDrop.addEventListener("drop", (e) => {
    e.preventDefault();
    imgFileDrop.files = e.dataTransfer.files;
    uploadImage();
  });
}
if (productImageDeleteBtn) {
  productImageDeleteBtn.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // Find the container that holds the img src text
      const container = btn.closest(".lt-image-img-container");
      const imgSrcElement = container.querySelector(".lt-img-src");
      const prodIdElement = container.querySelector(".lt-prod-id");

      // Get the text value (imageUrl)
      const imageUrl = imgSrcElement.textContent.trim();
      const prodID = prodIdElement.textContent.trim();

      console.log("Image URL to delete:", imageUrl);
      console.log("Product ID for image:", prodID);
      deleteProductImage(prodID, imageUrl);
    });
  });
}

// Active Navbar Link
if (navLiBack) {
  // Get current URL and endpoint
  const currentPageUrl = window.location.href;
  const endpoint = currentPageUrl.substring(
    currentPageUrl.lastIndexOf("/") + 1
  );

  // Jank way of finding which nav link is active
  let activeClass;
  switch (endpoint) {
    case "mySales":
      activeClass = "nav-mySales";
      break;
    case "myQueue":
      activeClass = "nav-myQueue";
      break;
    case "overview":
      activeClass = "nav-overview";
      break;
    case "palletHub":
      activeClass = "nav-palletHub";
      break;
    case "pricing":
      activeClass = "nav-pricing";
      break;
    case "me":
      activeClass = "nav-me";
      break;
    default:
      activeClass = "innactive";
  }

  // Add active styling to nav item
  if (activeClass !== "innactive") {
    const activeNav = document.querySelector(`.${activeClass}`);
    activeNav.classList.add("nav-active");
  }
}
if (loginForm) {
  // DELEGATION
  document.querySelector(".form").addEventListener("submit", (e) => {
    e.preventDefault(); // Prevents the form from loading any other pages
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    login(email, password);
  });
}
if (logOutBtn) {
  logOutBtn.addEventListener("click", logout);
}
if (contactForm) {
  contactForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const contactName = document.getElementById("contactName").value;
    const contactEmail = document.getElementById("contactEmail").value;
    const contactMessage = document.getElementById("contactMessage").value;

    sendCarrier(contactName, contactEmail, contactMessage);
  });
}
if (userDataForm) {
  userDataForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const name = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    updateSettings({ name, email }, "data");
  });
}
if (csvDataForm) {
  csvDataForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("currentBid", document.getElementById("currentBid").value);
    formData.append(
      "shipping_cost",
      document.getElementById("shipping_cost").value
    );
    const palletItemsInput = document.getElementById("palletItems");
    formData.append("palletItems", palletItemsInput.files[0]);
    buildPallet(formData, "data");
  });
}
if (addItemForm) {
  addItemForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const itemNumber = document.getElementById("itemNumber").value;
    const itemDescription = document.getElementById("itemDescription").value;
    const usersPrice = document.getElementById("usersPrice").value;

    createItem(itemNumber, itemDescription, usersPrice);
  });
}
if (editItemForms) {
  editItemForms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const eClass = e.submitter.className.split("content-btn item-")[1];

      if (eClass.startsWith("save")) {
        const itemNumber = eClass.split("save-")[1];
        const usersPrice = document.getElementById(
          `usersPrice-${itemNumber}`
        ).value;
        editItem(itemNumber, usersPrice);
      } else if (eClass.startsWith("dlt")) {
        const itemNumber = eClass.split("delete-")[1];
        deleteItem(itemNumber);
      }
    });
  });
}
if (listThisForm) {
  listThisForm.addEventListener("submit", (e) => {
    e.preventDefault();
    // Retrieving the productID
    const submitterClass = e.submitter.className;

    // Delegation For Listing
    if (submitterClass.startsWith("list")) {
      const eClass = submitterClass.split(
        "list-this-btn list-this-btn-list "
      )[1];
      const productID = eClass.split("list-")[1];
      const productTitle = document.getElementById("ltd-product-title").value;
      const listPrice = document.getElementById("ltd-product-listPrice").value;
      const description = document.getElementById("ltd-product-desc").value;
      const features = [
        ...document.getElementsByClassName("existing-feature"),
      ].map((element) => element.textContent);

      const formUpdates = {
        id: productID,
        mainFeatures: features,
        title: productTitle,
        listPrice: listPrice * 1,
        description: description,
      };

      listProduct(formUpdates);
    }

    // Delegation For Saving
    if (submitterClass.startsWith("save")) {
      const eClass = submitterClass.split("save-this-btn list-this-btn")[1];

      const productID = eClass.split("save-")[1];
      const productTitle = document.getElementById("ltd-product-title").value;
      const listPrice = document.getElementById("ltd-product-listPrice").value;
      const description = document.getElementById("ltd-product-desc").value;
      const features = [
        ...document.getElementsByClassName("existing-feature"),
      ].map((element) => element.textContent);

      const formUpdates = {
        id: productID,
        mainFeatures: features,
        title: productTitle,
        listPrice: listPrice * 1,
        description: description,
      };

      saveProduct(formUpdates);
    }
  });
}
if (userPasswordForm) {
  userPasswordForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    document.querySelector(".btn--save-password").innerHTML = "Updating...";

    const passwordCurrent = document.getElementById("password-current").value;
    const password = document.getElementById("password").value;
    const passwordConfirm = document.getElementById("password-confirm").value;
    await updateSettings(
      { passwordCurrent, password, passwordConfirm },
      "password"
    );

    document.getElementById("password-current").value = "";
    document.getElementById("password").value = "";
    document.getElementById("password-confirm").value = "";
    document.querySelector(".btn--save-password").innerHTML = "Save Password";
  });
}
if (deletePalletBtn) {
  deletePalletBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    const lotNumber = document.getElementById("pst-spn").innerText;
    document.querySelector(".pallet-dlt").innerHTML = "DELETING...";
    deletePallet(lotNumber, "delete");
  });
}
if (sellPalletBtn) {
  sellPalletBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    const lotNumber = document.getElementById("pst-spn").innerText;

    const confirmed = window.confirm(
      "Are you sure? This will queue every item in this pallet on you sales page."
    );

    if (confirmed) {
      prepPallet(lotNumber);

      document.querySelector(".palletDet-sell-btn").innerHTML = "Pallet Preped";
      document.querySelector(".palletDet-sell-btn").style.color = "#2ecc71";
      document.querySelector(".palletDet-sell-btn").style.backgroundColor =
        "#ffffff";
    }
  });
}
if (addFeatureBtn) {
  addFeatureBtn.addEventListener("click", async (e) => {
    console.log("Add Feature clicked.");
    e.preventDefault();

    // Get input value
    const inputValue = document.getElementById("ltd-product-features").value;

    if (!inputValue) {
      showAlert("error", "Please provide input to add feature.");
    } else {
      // Create new feature block
      const newBlock = document.createElement("div");
      newBlock.className = "existing-feature-block";

      // Create feature heading
      const featureHeading = document.createElement("h4");
      featureHeading.className = "existing-feature";
      featureHeading.textContent = inputValue;

      // Create remove button
      const removeButton = document.createElement("button");
      removeButton.className = "existing-feature-remove";
      removeButton.type = "button";
      removeButton.textContent = "x";

      // Assemble the block
      newBlock.appendChild(featureHeading);
      newBlock.appendChild(removeButton);

      // Insert after existing blocks
      document
        .querySelector(".existing-feature-container")
        .appendChild(newBlock);

      // Clear input field ltd-product-features
      document.getElementById("ltd-product-features").value = "";
    }
  });
}
if (removeFeatureBtn.length > 0) {
  removeFeatureBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const parentElement = e.target.parentElement;
      if (parentElement) {
        parentElement.remove();
      }
    });
  });
}
if (carouselBtns.length > 0) {
  console.log("found carouself btns");
  carouselBtns.forEach((button) => {
    button.addEventListener("click", () => {
      const offset = button.dataset.carouselButton === "next" ? 1 : -1;
      const slides = button
        .closest("[data-carousel]")
        .querySelector("[data-slides]");

      const activeSlide = slides.querySelector("[data-active]");
      let newIndex = [...slides.children].indexOf(activeSlide) + offset;
      if (newIndex < 0) newIndex = slides.children.length - 1;
      if (newIndex >= slides.children.length) newIndex = 0;

      slides.children[newIndex].dataset.active = true;
      delete activeSlide.dataset.active;
    });
  });
}
if (unlistBtn) {
  unlistBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const submitterClass = e.target.className;
      const productId = submitterClass.split("my-product-unlist id-")[1];
      unlistProduct(productId);
    });
  });
}

if (soldBtn) {
  soldBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const submitterClass = e.target.className;
      const productId = submitterClass.split("my-product-sold id-")[1];
      markAsSold(productId);
    });
  });
}
